/**
 * TODO
 * drag search
 */

import queryString from 'global/js/query-string.js';
import React, { useEffect, useState } from 'react';
import { getApi } from '../../../../global/js/api';
import { utils } from '../../../../global/js/utils.js';
import BookOnlineBlock from '../../bookOnlineBlock/js/BookOnlineBlock.jsx';
import MapViewBlock from '../../mapViewBlock/js/MapViewBlock.jsx';
import MonthlyRecommendedParking from '../../MonthlyRecommendedParking/js/MonthlyRecommendedParking.jsx';
import SimpleLocationSearchBar from './SimpleLocationSearchBar.jsx';
import SimpleLocationSearchResult from './SimpleLocationSearchResult.jsx';

const SimpleLocationSearchContainer = (props) => {
  const [carParks, setCarParks] = useState([]);
  const [activeCarPark, setActiveCarPark] = useState(null);
  const [loadingHook, setLoadingHook] = useState(false);

  // book online
  const [bookOnlinePark, setBookOnlinePark] = useState('');
  const [bookOnlineState, setBookOnlineState] = useState('');
  const [carParkCode, setCarParkCode] = useState('');

  // top search bar
  const [sort, setSort] = useState([]);
  const [currentSort, setCurrentSort] = useState('');

  // recommended car parking
  const [parkingLocation, setParkingLocation] = useState(
    props.userLocation || null
  );

  const [filters, setFilters] = useState([]);

  // contains geolocation for Google map api
  // type is pos returning Google geo json
  const [currentLocation, setCurrentLocation] = useState(props.userLocationPos);

  // just for string address text
  const [currentAddress, setCurrentAddress] = useState('');

  const [destination, setDestination] = useState(props.destination);
  const [mapData, setMapData] = useState({
    center: {
      lat: props.destination.lat,
      lng: props.destination.lng,
    },
    distance: props.destination.distance,
  });

  const [zoom, setZoom] = useState(props.zoom || 12);

  // for mobile device view exchange
  const [viewBtnText, setViewBtnText] = useState('List View');
  const [mapViewClass, setMapViewClass] = useState('');

  /**
   * initial loading the component
   */
  useEffect(() => {
    fetchParkings();
  }, []);

  /**
   * @carParkFeature car park selected filters value
   * @inputDest address search bar address data
   * @carParkFeature selected car park feature array
   */
  const getSearchQuery = (inputDest) => {
    const parsedQuery = queryString.parse(location.search);
    // const lat = parsedQuery.lat;
    // const lng = parsedQuery.lng;
    const sort = parsedQuery.sort;
    const carParkFeature = parsedQuery.carParkFeature;

    return `pageid=${props.pageid}&latitude=${inputDest.lat}&longitude=${
      inputDest.lng
    }&carParkFeature=${carParkFeature}&sort=${sort}&distance=${
      inputDest.distance === undefined ? 20 : inputDest.distance
    }`;
  };

  const getMinViewScreenToDistance = (realZoom, realLat) => {
    // let tempZoom = realZoom? realZoom : zoom;
    // let tempLat = realLat ? realLat : mapData.center.lat;

    // // const zoomMeterPerPixels = [ 21282, 16355, 10064, 5540, 2909, 1485, 752, 378, 190, 95, 48, 24, 12, 6, 3, 1.48, 0.74, 0.37, 0.19 ];
    // // const zoomMeterPerPixel = zoomMeterPerPixels[tempZoom];
    // const mapContainer = document.getElementById('mapContainer');
    // const visibleScreenPixels = 0.5 * Math.max(mapContainer.clientWidth, mapContainer.clientHeight == 0 ? 672 : mapContainer.clientHeight);

    // // const distance = visibleScreenPixels * zoomMeterPerPixel;

    // const distance = visibleScreenPixels * 156543.03392 * Math.cos(tempLat * Math.PI / 180) / Math.pow(2, tempZoom);

    // // console.log(distance, tempZoom, tempLat);

    // return distance / 1000;
    return 20;
  };

  const fetchRecommendedParkings = (inputDest) => {
    // console.log('fetchRecommendedParkings', inputDest);
    setParkingLocation({
      lat: inputDest.lat,
      lng: inputDest.lng,
    });
  };

  /**
   *  re-rendering carpark api call
   */
  const fetchParkings = (inputDest, updateDestination = true) => {
    console.log('fetchParkings', inputDest);
    let apiUrl = '';

    // if address search bar update address :)
    if (inputDest) {
      setMapData({
        center: {
          lat: inputDest.lat,
          lng: inputDest.lng,
        },
        distance: inputDest.distance
          ? inputDest.distance
          : getMinViewScreenToDistance(),
      });

      if (updateDestination === true) {
        setDestination({
          lat: inputDest.lat,
          lng: inputDest.lng,
          // distance: destination.distance
          distance: inputDest.distance
            ? inputDest.distance
            : getMinViewScreenToDistance(),
        });
      }

      apiUrl = `${props.api}?${getSearchQuery(inputDest)}`;
    } else {
      // if address search bar not update address
      // just update filter or sort
      // then just use current mapCenter from State
      const parsedQuery = utils.getLocationFromStorage();
      if (parsedQuery) {
        apiUrl = `${props.api}?${getSearchQuery(parsedQuery)}`;
      } else {
        let tempRadius = getMinViewScreenToDistance();
        let tempDest = {
          lat: mapData.center.lat,
          lng: mapData.center.lng,
          distance: tempRadius,
        };
        apiUrl = `${props.api}?${getSearchQuery(tempDest)}`;
      }
    }

    setLoadingHook(true);
    // reset car parks every time call api
    setCarParks([]);
    getApi(apiUrl).then((data) => {
      console.log(data);

      // set all data hooks
      setCarParks(data.carParks);
      setSort(data.sort);
      setFilters(data.filters);
      updateFiltersQuery(data.filters);

      setLoadingHook(false);
    });
  };

  /**
   * updating the filters hook when
   * updating the checkobxes
   * @param {name, bool} filter
   */
  const updateFilters = (filter) => {
    console.log('updateFilters', filter, filters);
    filters.map((el) => {
      if (el.key === filter.key) {
        el.filtered = filter.filtered;
      }
      return el;
    });
    setFilters(JSON.parse(JSON.stringify(filters)));
  };

  const applyFilters = () => {
    updateFiltersQuery(filters);
    fetchParkings();
  };

  const updateFiltersQuery = (filters) => {
    // get carParkFeature array & query binding
    let carParkFeature = filters
      .filter((el) => {
        return el.filtered === true;
      })
      .map((el) => el.key);
    window.history.replaceState(
      '',
      '',
      utils.updateURLParameter(
        window.location.href,
        'carParkFeature',
        carParkFeature
      )
    );
  };

  /**
   * when car park result sort is
   * updating trigger api call
   */
  const applySort = (sortkey) => {
    console.log('applySort', sortkey);
    window.history.replaceState(
      '',
      '',
      utils.updateURLParameter(window.location.href, 'sort', sortkey)
    );
    setCurrentSort(sortkey);

    // update the sort
    // call carpark fetch api
    fetchParkings();
  };

  /**
   * these 3 functions for handling click event
   * for marker, left carpark result to set
   * current selected active car park in the result
   * and in the map view block
   *
   * @function handleActiveCarPark
   * @function handleClickMarker
   * @function selectCarPark
   *
   */
  const handleActiveCarPark = (carPark) => {
    selectCarPark(carPark);
  };

  const handleClickMarker = (carPark) => {
    selectCarPark(carPark);
  };

  const selectCarPark = (carPark) => {
    if (carPark) {
      setActiveCarPark(carPark);
    }
  };

  const handleCurrentAddress = (address) => {
    console.log('handleCurrentAddress', address);
    setCurrentAddress(address);
  };

  /**
   * exchange list view / map view in mobile device
   *  */
  const handleViewChange = (text) => {
    let newBtnText = text == 'List View' ? 'Map View' : 'List View';
    setViewBtnText(newBtnText);
    if (newBtnText === 'List View') {
      setMapViewClass('visible');
    }
    if (newBtnText === 'Map View') {
      setMapViewClass('invisible');
    }
  };

  const handleMapChanged = (center, zoom, bounds, marginBounds) => {
    // const maxDistance = getDistanceFomGeoPoints(bounds.nw.lat, bounds.nw.lng, bounds.ne.lat, bounds.ne.lng);
    // const radius = maxDistance / 2;

    // if (Number.isNaN(radius)) {
    // 	return;
    // }
    let radius = getMinViewScreenToDistance(zoom, center.lat);
    // console.log('handleMapChanged!', zoom, radius);

    setZoom(zoom);

    // dont need update map center data, will do in the api fetching...
    // call carpark api but
    // not update destination
    // fetchParkings({
    // 	lat: center.lat,
    // 	lng: center.lng,
    // 	distance: radius,
    // }, false);

    fetchRecommendedParkings({
      lat: center.lat,
      lng: center.lng,
    });
  };

  const updateCarParkCode = (url, carParkCodeValue) => {
    const urlObj = new URL(url);
    if (urlObj.searchParams.has('carParkCode')) {
      urlObj.searchParams.set('carParkCode', carParkCodeValue);
    } else {
      urlObj.searchParams.append('carParkCode', carParkCodeValue);
    }
    return urlObj.toString();
  };

  const formatBookUrl = (carParkNumber) => {
    // let url = `https://bookabay.wilsonparking.com.au/public/flow.htm?_flowId=makeBooking-flow&carParkCode=${carParkNumber}`;
    return updateCarParkCode(props.bookABayUrl, carParkNumber);
  };

  return (
    <div className='position-relative'>
      {props.type == 'bookonline' && (
        <BookOnlineBlock
          bookOnlinePark={bookOnlinePark}
          bookOnlineState={bookOnlineState}
          carParkCode={carParkCode}
          setCarParkCode={setCarParkCode}
          setBookOnlinePark={setBookOnlinePark}
          setBookOnlineState={setBookOnlineState}
          stayLongerText={props.stayLongerText}
          stayLongerUrl={props.stayLongerUrl}
          autocompleteApi={props.autocompleteApi}
          states={props.states}
          bookonlineTitle={props.bookonlineTitle}
          bookonlineDesc={props.bookonlineDesc}
          bookonlinePlaceholder={props.bookonlinePlaceholder}
          bookonlineWheretofind={props.bookonlineWheretofind}
          submitButtonLabel={props.submitButtonLabel}
          bookABayUrl={props.bookABayUrl}
        />
      )}

      {props.recommendedParkingFeature && (
        <div
          className={`monthlyRecommendedParking ${props.recommendedParkingBgColor}`}
        >
          <MonthlyRecommendedParking
            title='Recommended Parking'
            hasPills={false}
            carParks={carParks.slice(0, 4)}
            // api= {props.recommendedParkingApi}
            api={'no'}
            userLocation={parkingLocation}
            cpms={props.cpms}
            useCurrentLocation={parkingLocation ? true : false}
            ctaText={props.recommendedParkingCtaText}
          />
        </div>
      )}

      <SimpleLocationSearchBar
        fetchParkings={fetchParkings}
        fetchRecommendedParkings={fetchRecommendedParkings}
        filters={filters}
        applyFilters={applyFilters}
        updateFilters={updateFilters}
        sort={sort}
        country={props.country}
        mainTitle={props.mainTitle}
        carparkfeature={props.carparkfeature}
      />
      <div className='row position-relative'>
        <div className='simpleLocationSearchResult col-12 col-lg-6 col-xl-5'>
          {/* Three types defined:
						1. monthly parking page "monthly"
						2. find a park page "findapark"
						3. book online page "bookonline"
					*/}
          <SimpleLocationSearchResult
            carParks={carParks}
            handleActiveCarPark={handleActiveCarPark}
            activeCarPark={activeCarPark}
            currentAddress={currentAddress}
            formatBookUrl={formatBookUrl}
            destination={destination}
            sort={sort}
            ctaText={props.ctaText}
            ctatarget={props.ctatarget}
            applySort={applySort}
            type={props.type}
            setBookOnlinePark={setBookOnlinePark}
            setBookOnlineState={setBookOnlineState}
            setCarParkCode={setCarParkCode}
            setMapData={setMapData}
            mapData={mapData}
            cpms={props.cpms}
          />
        </div>
        <div
          className={
            'mapViewBlock col-12 col-lg-6 col-xl-7 px-0 ' + mapViewClass
          }
          id='mapContainer'
        >
          <MapViewBlock
            type={props.type}
            mapData={mapData}
            zoom={props.zoom}
            infoWindowData={activeCarPark}
            carParks={carParks}
            activeCarPark={activeCarPark}
            handleClickMarker={handleClickMarker}
            destination={destination}
            ctaText={props.ctaText}
            ctatarget={props.ctatarget}
            currentLocation={currentLocation}
            handleCurrentAddress={handleCurrentAddress}
            onMapChange={handleMapChanged}
            // setMapData={setMapData}

            clearInfo={() => setActiveCarPark(null)}
            formatBookUrl={formatBookUrl}
            // OnFilterList={OnFilterList}
            setBookOnlinePark={setBookOnlinePark}
            setBookOnlineState={setBookOnlineState}
            setCarParkCode={setCarParkCode}
            iconBookOnline={props.iconBookOnline}
            iconMonthlyParking={props.iconMonthlyParking}
            iconParkingCard={props.iconParkingCard}
            iconEvCharger={props.iconEvCharger}
            iconLabelBookOnline={props.iconLabelBookOnline}
            iconLabelMonthlyParking={props.iconLabelMonthlyParking}
            iconLabelParkingCard={props.iconLabelParkingCard}
            iconLabelEvCharger={props.iconLabelEvCharger}
            cpms={props.cpms}
          />
        </div>
        <div className='view-btn-wrapper d-flex d-lg-none'>
          <div
            className='view-btn'
            onClick={() => handleViewChange(viewBtnText)}
          >
            {viewBtnText}
          </div>
        </div>
        <div></div>
      </div>

      {/* loading spinner */}
      {
        <div className={`loading-spinner ${loadingHook ? 'is-active' : ''}`}>
          <img src='/assets/images/spinner.gif' />
        </div>
      }
    </div>
  );
};

SimpleLocationSearchContainer.defaultProps = {
  recommendedParkingCtaText: 'Get a quote',
  recommendedParkingBgColor: 'blue',
};
export default SimpleLocationSearchContainer;
